import { render, staticRenderFns } from "./ModalDistrito.vue?vue&type=template&id=0519082c"
import script from "./ModalDistrito.vue?vue&type=script&lang=js"
export * from "./ModalDistrito.vue?vue&type=script&lang=js"
import style0 from "./ModalDistrito.vue?vue&type=style&index=0&id=0519082c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports